export { FieldPartCategory, PART_CATEGORY_OFF_THE_SHELF } from './FieldPartCategory';
